import { NgOptimizedImage } from '@angular/common';
import { Component, output } from '@angular/core';
import { UiButtonComponent, UIIconComponent } from '@design-system';
import { WALLET_ACTIONS } from '../../domain/wallet-actions.constants';
import { WalletAction } from '../../domain/wallet-actions.model';

/**
 * واریز، انتقال، برداشت and تاریخچه — the four tiles under the balance card.
 *
 * Entry points only: each one emits, and the page decides what opening it means —
 * واریز and برداشت are stopped there for a customer without a کد بورس کالا.
 */
@Component({
	selector: 'app-wallet-actions',
	imports: [NgOptimizedImage, UiButtonComponent, UIIconComponent],
	templateUrl: './wallet-actions.component.html',
	host: { class: 'block w-full', 'data-cy': 'wallet-actions' }
})
export class WalletActionsComponent {
	readonly actionRequested = output<WalletAction>();

	readonly actions = WALLET_ACTIONS;
}
